// extracted by mini-css-extract-plugin
module.exports = {"Loader":"LoaderWithText-module--Loader--1pH6s","Text":"LoaderWithText-module--Text--3gB0c","ldsCircle":"LoaderWithText-module--ldsCircle--2tDaR"};